// Module
var code = "<materials></materials>\n";
// Exports
module.exports = code;